import i18n from '../i18n';
import { _todayKey } from './triviaHelpers';

export function normalizeHoroscopeLocale(value, fallback = 'es') {
  const base = String(value || '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return base === 'es' || base === 'en' ? base : fallback;
}

export function getActiveHoroscopeLocale() {
  return normalizeHoroscopeLocale(i18n.resolvedLanguage || i18n.language);
}

export function horoscopeTodayCacheKey(uid, locale) {
  const safeUid = uid ? String(uid) : 'anon';
  return `home:horoscope:today:${safeUid}:${_todayKey()}:${normalizeHoroscopeLocale(locale)}`;
}

export function legacyHoroscopeTodayCacheKey(uid) {
  const safeUid = uid ? String(uid) : 'anon';
  return `home:horoscope:today:${safeUid}:${_todayKey()}`;
}
